const matchTags = /<[^>]*>/g;
const matchNewlineTags = /<(br|div|hr|p)( [^>]*)?>/g;

/**
 * Note: this needs to work in browser and node
 */
export function htmlToText(html) {
  return ('' + (html || ''))
    .replace(matchNewlineTags, '\n')
    .replace(matchTags, '');
}
